import { BetQLSportItem } from "./";

const WTAConfig: BetQLSportItem = {
  id: "843930bd-f752-4f34-9a76-194c76e1f0fb",
  name: "WTA Tennis",
  url: "wta",
  tabName: "WTA",
  icon: "tennis",
  imagePath: "WTA",
  key: "WTA",
  lookupKey: "wta",
  favoriteLine: "moneyline",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: false,
  has1HtotalPowerRating: false,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: false,
  hasNews: false,
  hasLineup: false,
  hasSchedule: true,
  hasConfiguredSchedule: false,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: false,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: false,
  hasRecommendedBets: false,
  hasPopularEvents: false,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,4,9,5,14]}',
  defaultColumnOrder: [2, 4, 9, 5, 14],
  publicThreshold: 60,
  sharpPercentThreshold: 25,
  sharpCountThreshold: 300,
  publicCountThreshold: 300,
  trendTypes: [
    { name: "Spread", key: "ats", url: "ats-odds" },
    { name: "Moneyline", key: "ml", url: "moneyline-odds" },
  ],
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline-odds",
    },
    {
      name: "Spread",
      key: "spread",
      url: "ats-odds",
    },
    {
      name: "Total",
      key: "total",
      url: "over-unders",
    },
  ],
  periods: ["FULLGAME"],
  periodKeys: ["FG"],
  pickTypes: ["moneyline", "spread", "total"],
};

export default WTAConfig;
